(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gift-card-recipient-fields"] && !Shopify.designMode) return;
  try {
    (function () {
    function localDateString(date) {
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      return year + '-' + month + '-' + day;
    }

    document.querySelectorAll('[data-gift-card-recipient]').forEach(function (root) {
      var toggle = root.querySelector('[data-gift-card-recipient-toggle]');
      var fields = root.querySelector('[data-gift-card-recipient-fields]');
      var sendOn = root.querySelector('[data-gift-card-send-on]');
      var offset = root.querySelector('[data-gift-card-offset]');
      if (!toggle || !fields) return;

      var today = new Date();
      var latest = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      latest.setDate(latest.getDate() + 90);
      if (sendOn) {
        sendOn.min = localDateString(today);
        sendOn.max = localDateString(latest);
      }
      if (offset) offset.value = String(today.getTimezoneOffset());

      function sync() {
        var enabled = toggle.checked;
        fields.hidden = !enabled;
        toggle.setAttribute('aria-expanded', enabled ? 'true' : 'false');
        fields.querySelectorAll('input, textarea').forEach(function (field) {
          field.disabled = !enabled;
        });
      }

      toggle.addEventListener('change', sync);
      sync();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-discovery-gift"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-pdp-discovery-open]');
    if (trigger) {
      var dialog = document.getElementById(trigger.getAttribute('aria-controls'));
      if (dialog && !dialog.open) dialog.showModal();
      return;
    }
    if (!event.target.matches('.pdp-discovery-dialog')) return;
    var rect = event.target.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
  });
  } catch(e) { console.error(e); }
})();

})();
